import { cookie, LOCALE_COOKIE_KEY } from "../../hooks/useTranslate";
export const formatPrice = ({ amount, currency, locale, isRounded = false, invalidValue = "n/a", options, }) => {
    const quantity = Number(amount);
    if (amount === null || isNaN(quantity)) {
        return invalidValue;
    }
    const formatter = new Intl.NumberFormat(locale || cookie.get()[LOCALE_COOKIE_KEY], {
        maximumFractionDigits: isRounded ? 0 : 2,
        minimumFractionDigits: isRounded ? 0 : undefined,
        style: "currency",
        currency: currency || "USD",
        currencyDisplay: "symbol",
        ...options,
    });
    if (currency === "CDN") {
        return formatter.format(quantity).replace("$", "CDN$");
    }
    return formatter.format(quantity);
};
